export const $ = (key) => document.querySelector(key);